
import {defineComponent} from "vue";
import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";
import {CbStructureMixin} from "@/components/layouts/content-pages/wysiwyg/structures/CbStructureMixin";
import {NormalContentBlockRestService} from "@/services/rest/cms-content-block/NormalContentBlockRestService";
import {FindNormalContentBlockPayload} from "@/models/payload/FindNormalContentBlockPayload";
import {CreateNormalContentBlockPayload} from "@/models/payload/CreateNormalContentBlockPayload";
import {SaveNormalContentBlockPayload} from "@/models/payload/SaveNormalContentBlockPayload";
import {DocumentContentRestDtoModel} from "@/models/api/pharma-cms-content-block/DocumentContentRestDtoModel";
import {EnumClassNameCmsEnum} from "@/models/enum/EnumClassNameCmsEnum";
import Subtitle from "@/components/UI/Subtitle.vue";
import BaseSpinner from "@/components/UI/Bootstrap/BaseSpinner.vue";
import InputCheckboxBoolean from "@/components/UI/InputCheckboxBoolean.vue";
import InputText from "@/components/UI/InputText.vue";
import InputSelect from "@/components/UI/InputSelect.vue";
import InputImage from "@/components/UI/InputImage.vue";
import {DpModuleEnum} from "@/api/enums/dp-module-enum";
import {DpException} from "@/exception/DpException";
import {EnumRestService} from "@/services/rest/enum/EnumRestService";

export default defineComponent({
  name: "CbDocument",
  components: {InputImage, InputSelect, InputText, InputCheckboxBoolean, BaseSpinner, Subtitle},
  extends: CbStructureMixin,
  data: () => ({
    contentBlock: DocumentContentRestDtoModel.createWithDefaults(),
    docType: 'PAGE_DOC' as string,
    btnLayoutOptions: [] as CodeDescriptionRestDto[]
  }),
  mounted() {
    this.initialize();
  },
  computed: {
    DpModuleEnum() {
      return DpModuleEnum;
    },
    existingDocumentKey(): string {
      return this.contentBlock.document_key;
    },
  },
  methods: {
    async find(payload: FindNormalContentBlockPayload): Promise<DocumentContentRestDtoModel> {
      return await NormalContentBlockRestService.getInstance().findDocument(payload.type, payload.id);
    },
    async create(payload: CreateNormalContentBlockPayload): Promise<string> {
      return await NormalContentBlockRestService.getInstance().createDocument(payload.cb as DocumentContentRestDtoModel, payload.type);
    },
    async save(payload: SaveNormalContentBlockPayload): Promise<void> {
      await NormalContentBlockRestService.getInstance().saveDocument(payload.cb as DocumentContentRestDtoModel, payload.type, payload.id);
    },
    async initialize(): Promise<void> {
      this.btnLayoutOptions = await EnumRestService.getInstance().getEnumValuesByClassName(EnumClassNameCmsEnum.BUTTON_LAYOUT, DpModuleEnum.CMS);
    },
    async beforeSubmitData(): Promise<void> {
      if (!this.contentBlock.document_key.length) {
        throw [new DpException(this.$t('documentRequired'))];
      }
    },
    getDefaultCbModel(): DocumentContentRestDtoModel {
      return DocumentContentRestDtoModel.createWithDefaults();
    },
    setDocumentKey(key: string | null) {
      this.contentBlock.document_key = key ?? '';
    },
    pasteCbMetadata(): void {
      this.contentBlock.cloneMetadataFrom(this.getClipboardContentBlock(this.cbType) as DocumentContentRestDtoModel);
    },
  }
});
